export default new SharedWorker(new URL('./worker-script.ts', import.meta.url), {
  type: 'module',
});
